module.exports = __webpack_public_path__ + "static/blok-a79e75b82ba33803a88b1eb52b7bdb4c.svg";